import locales from '../locales';

const provider = (key) => {
    const locale = locales[key] || locales['en'];
    return locale.messages;
};

export default provider;